import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  ElementRef,
  ViewChild,
  HostListener,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "app-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ModalComponent {
  @Input() item;
  @Input() client;
  @Input() helpOpened;
  @Input() movementType;
  @Output() close: EventEmitter<string> = new EventEmitter();
  public currentContent = "information";
  public maximized = false;
  public innerWidth;

  constructor() {
    this.innerWidth = window.innerWidth;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  isMobile() {
    return innerWidth < 800 && this.currentContent == "360";
  }

  public changeContent(content: string) {
    this.currentContent = content;
  }

  closeMe() {
    this.close.emit();
  }

  isMaximized() {
    return this.maximized && this.currentContent == "360";
  }

  maximizeWindow() {
    this.maximized = !this.maximized;
  }
}
